import React, { useCallback, useEffect, useState } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getTopVulnerableCategory, getTopVulnerabilityStats } from "../../../../../store/actions/dashboardAction";

import { formatNumber } from "../../../../../utils/util";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

const TopSubDomains = () => {

    const vulnerableCategoryResponse = useSelector((state) => state.dashboard.vulnerableCategory);
    const vulnearbilityStatsResponse = useSelector((state) => state.dashboard.vulnearbilityStats)
 
    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [categoryLoading, setCategoryLoading] = useState(false);
    const [categoryListLoading, setCategoryListLoading] = useState(false);

    const fetchVulnerableSubdomain = useCallback(()=>{
        setCategoryLoading(true)
        setCategoryListLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        dispatch(getTopVulnerableCategory(params))       
        dispatch(getTopVulnerabilityStats(params))   
    },[organizationId, domainId, scanId, dispatch])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchVulnerableSubdomain()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchVulnerableSubdomain]);

    useEffect(()=>{
        if(vulnerableCategoryResponse !== null) {
            setCategoryLoading(false)
        }
    },[vulnerableCategoryResponse])

    useEffect(()=>{
        if(vulnearbilityStatsResponse !== null) {
            setCategoryListLoading(false)
        }
    },[vulnearbilityStatsResponse])

    return (
        <>          

            <Row className="mt-4">
                <Col lg={6}>
                    {
                        categoryLoading ?
                        <SkeletonLoader type={"line"} count={6} />
                        :
                        <motion.div
                            className="h-100"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4 h-100">
                                <div className="d-flex justify-content-between dashboard-box-container">
                                    <p className="heading font-bold">Top Vulnerable Category</p>
                                </div>
                                <div className="vulnerable-list-container">
                                    {
                                        vulnerableCategoryResponse?.stats?.category?.length > 0 &&
                                        vulnerableCategoryResponse?.stats?.category?.map((data, index)=>{
                                            return (
                                                <div className="dashboard-type-container rounded p-3 mt-3" key={index}>
                                                    <div className="align-items-center">
                                                        <Row className="justify-content-between">
                                                            <Col lg={1}>
                                                                <p className="number-count mb-0">{index+1}</p>
                                                            </Col>
                                                            <Col lg={8}>
                                                                <div className="count-top d-flex align-items-center h-100">
                                                                    <p className="sens mb-0 mt-1 ms-3">{data?.name}</p>
                                                                    {/* <p className="cred mb-0 ms-3">Credential disclosure check</p> */}
                                                                </div>
                                                            </Col>
                                                            <Col lg={3}>
                                                                <div className="count-top d-flex justify-content-end gap-3 mt-2">
                                                                    {/* <p className="active mb-0">Potential</p> */}
                                                                    <p className="count-cred mb-0">Count:&nbsp;<span className='font-bold'>{formatNumber(data?.count)}</span></p>
                                                                    {/* <p className="mt-1 mb-0">
                                                                        <img src={send} alt="send" />
                                                                    </p> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        vulnerableCategoryResponse?.stats?.category?.length === 0 &&
                                        <NoDataFound />
                                    }
                                    {
                                        (vulnerableCategoryResponse?.status === "failed" || vulnerableCategoryResponse === "Not Found") &&
                                        <NoDataFound noDataText={vulnerableCategoryResponse?.description} />
                                    }
                                </div>
                            </div>
                        </motion.div>
                    }                    
                </Col>
                <Col lg={6}>
                    {
                        categoryListLoading ?
                        <SkeletonLoader type={"line"} count={6} />
                        :
                        <motion.div
                            className="h-100"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4 h-100">
                                <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                                    <p className="heading font-bold">Top Vulnerabilities in Web applications</p>
                                    {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                </div>
                                <div className="vulnerable-list-container">
                                    {
                                        vulnearbilityStatsResponse?.stats?.vulnerability?.length > 0 &&
                                        vulnearbilityStatsResponse?.stats?.vulnerability?.map((data, index)=>{
                                            return (
                                                <div className="dashboard-type-container rounded p-3 mt-3" key={index}>
                                                    <Row>
                                                        <Col lg={7}>
                                                            <div className="count-top align-items-center">
                                                                <p className="sens mb-0">{data?.name}</p>
                                                                <p className="secondary-text mb-0"><span>Category :</span> {data?.category}</p>
                                                            </div>
                                                        </Col>
                                                        <Col lg={5}>
                                                            <div className="count-top d-flex align-items-center justify-content-end gap-3 h-100">
                                                                <p className={`severity mb-0 ${data?.severity}`}>{data?.severity}</p>
                                                                <p className="count-cred mb-0">Count:&nbsp;<span className='font-bold'>{formatNumber(data?.count)}</span></p>
                                                                {/* <p className="mt-1 mb-0">
                                                                    <img src={send} alt="send" />
                                                                </p> */}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        vulnearbilityStatsResponse?.stats?.vulnerability?.length === 0 &&
                                        <NoDataFound />
                                    }
                                    {
                                        (vulnearbilityStatsResponse?.status === "failed" || vulnearbilityStatsResponse === "Not Found") &&
                                        <NoDataFound noDataText={vulnearbilityStatsResponse?.description} />
                                    }
                                </div>
                            </div>
                        </motion.div>
                    }                    
                </Col>
            </Row>

        </>

    )
}


export default TopSubDomains;